import auth from "./auth";
import takebaker from "./takebaker";
import modelManager from "./modelManager";
// import { initWS, closeWS } from "./websockets";

// export default { auth, takebaker, models, initWS, closeWS };
export default { auth, takebaker, modelManager };
